var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_32858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.998 27.2C16.6693 27.2 23.998 29.0425 23.998 32.7V35.45H1.99805V32.7C1.99805 29.0425 9.3268 27.2 12.998 27.2Z",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0811 24C16.1198 24 18.5811 21.5388 18.5811 18.5C18.5811 15.4613 16.1198 13 13.0811 13C10.0423 13 7.58105 15.4613 7.58105 18.5C7.58105 21.5388 10.0423 24 13.0811 24Z",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 2,
    height: 10,
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 2,
    height: 8,
    transform: "rotate(90 31 18)",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 30.8522C32.7334 29.4979 37.0001 24.3472 37.0001 18.2C37.0001 11.0203 31.1798 5.20001 24.0001 5.20001C19.925 5.20001 16.2878 7.07505 13.9042 10.0094C13.7703 10.0032 13.6356 10 13.5001 10C12.7194 10 11.9632 10.1053 11.2451 10.3023C13.8905 6.03904 18.6137 3.20001 24.0001 3.20001C32.2843 3.20001 39.0001 9.91574 39.0001 18.2C39.0001 25.4569 33.8468 31.5102 27 32.9V30.8522Z",
    fill: "#95A3B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_32858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33.6,
    fill: "white",
    transform: "translate(0 3.20001)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAppIcon);
export default __webpack_public_path__ + "static/media/office-app-icon.d3beb533.svg";
export { ForwardRef as ReactComponent };